module.exports = __webpack_public_path__ + "img/healthcare-final.9a429699.jpg";